import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';

const socialPosts = [
  { id: 1, image: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/nppzerfn_Chicken%20Tacos.jpg" },
  { id: 2, image: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/7csegdy5_Oaxaca%20Old-%20Fashioned.jpg" },
  { id: 3, image: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mar8qk2z_Churros.jpg" },
  { id: 4, image: "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/wgn5ctmv_WhatsApp%20Image%202026-03-26%20at%2012.30.53%20%282%29.jpeg" }
];

const SocialMediaSection = () => {
  return (
    <section className="relative py-20" style={{ backgroundColor: '#1A1918' }} data-testid="social-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mb-4" style={{ textShadow: '3px 3px 0 rgba(238,37,53,0.3)' }} data-testid="social-title">
            FOLLOW THE FIESTA
          </h2>
          <p className="font-mono text-gray-500 max-w-xl mx-auto mb-8 text-sm">
            Stay connected with Casa Loco India for the latest updates, mouth-watering pics, and exclusive offers.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <a href="https://www.instagram.com/casalocoindia/" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-2 text-white px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-wider transition-transform hover:translate-y-[-2px]"
              data-testid="social-instagram"
              style={{ backgroundColor: '#EE2535', border: '2px solid #F7B638', boxShadow: '3px 3px 0 #F7B638' }}>
              <Instagram className="w-4 h-4" /> @casalocoindia
            </a>
            <a href="https://www.facebook.com/casalocoindia/" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-2 text-white px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-wider transition-transform hover:translate-y-[-2px]"
              data-testid="social-facebook"
              style={{ backgroundColor: '#1877F2', border: '2px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}>
              <Facebook className="w-4 h-4" /> Facebook
            </a>
            <a href="https://www.linkedin.com/company/casalocoindia" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-2 text-white px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-wider transition-transform hover:translate-y-[-2px]"
              data-testid="social-linkedin"
              style={{ backgroundColor: '#0A66C2', border: '2px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}>
              <Linkedin className="w-4 h-4" /> LinkedIn
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {socialPosts.map((post) => (
            <a key={post.id} href="https://www.instagram.com/casalocoindia/" target="_blank" rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
              data-testid={`social-post-${post.id}`}
              style={{ border: '3px solid #1A1918', boxShadow: '3px 3px 0 #F7B638' }}>
              <img src={post.image} alt="Casa Loco Instagram" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <div className="text-white text-center">
                  <Instagram className="w-7 h-7 mx-auto mb-1" />
                  <p className="text-xs font-mono font-bold">View on Instagram</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="font-mono text-gray-500 text-sm">
            Share your experience with <span className="font-bold" style={{ color: '#F7B638' }}>#CasaLocoIndia</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;
